import CheckoutCard from './checkout-card.vue';

export default CheckoutCard;
